module.exports = __webpack_public_path__ + "img/emoji_kuxiao.f2f8e142.png";